import { TRANSACTIONS_HEADERS } from "../types/transactionsHeadersTypes";

export interface ITransactionsHeaders {
  accountant: string;
  client: string;
  clientType: string | number;
  type: string;
  transactionMethod: string | number;
  dateAppliesOn: string | number;
  startDate: string | null;
  endDate: string | null;
}

const initialState: ITransactionsHeaders = {
  accountant: "all",
  client: "all",
  clientType: "all",
  type: "all",
  transactionMethod: "all",
  dateAppliesOn: "all",
  startDate: null,
  endDate: null,
};

export const transactionsHeadersReducer = (
  state: ITransactionsHeaders = initialState,
  action: any,
): ITransactionsHeaders => {
  switch (action.type) {
    case TRANSACTIONS_HEADERS.TRANSACTIONS_HEADERS_SET_SELECTED:
      return {
        ...state,
        ...action.payload,
        // ...state,
        // accountant: action.payload.accountant,
        // client: action.payload.client,
        // clientType: action.payload.clientType,
        // type: action.payload.type,
        // dateAppliesOn: action.payload.dateAppliesOn,
        // startDate: action.payload.startDate,
        // endDate: action.payload.endDate,
      };
    case TRANSACTIONS_HEADERS.TRANSACTIONS_HEADERS_CLEAR_SELECTED:
      return {
        ...state,
        accountant: initialState.accountant,
        client: initialState.client,
        clientType: initialState.clientType,
        type: initialState.type,
        transactionMethod: initialState.transactionMethod,
        dateAppliesOn: initialState.dateAppliesOn,
        startDate: initialState.startDate,
        endDate: initialState.endDate,
      };
    default:
      return state;
  }
};
